import QUERYPARAMS_GET_SUCCESS from '../actionTypes/QueryParamsActionTypes';

function QueryparamsReducer(state = {}, action) {
    switch (action.type) {
        case QUERYPARAMS_GET_SUCCESS:
            return action.payload || state;
        default:
            return state;
    }
}

export default QueryparamsReducer;
